import { CalendarDays, Clock, MapPin } from "lucide-react";
import { useMakeABookingDialog } from "../useMakeABookingDialog";
import { calculateEndTime, formatDateForDisplay, formatDuration, formatTimeForDisplay } from "../utils";

export const BookingSummary = () => {
  const { formData } = useMakeABookingDialog();

  const endTime = calculateEndTime(formData.time, formData.durationMinutes);

  return (
    <div className="space-y-3">
      {/* Location and Room - single line */}
      <div className="flex items-center gap-2 text-sm">
        <MapPin className="h-4 w-4 text-gray-500 flex-shrink-0" />
        <span className="text-gray-700">
          {formData.locationName}
          {formData.roomName && (
            <>
              <span className="text-gray-400 mx-1">/</span>
              <span className="font-medium">{formData.roomName}</span>
            </>
          )}
        </span>
      </div>

      {/* Date */}
      <div className="flex items-center gap-2 text-sm">
        <CalendarDays className="h-4 w-4 text-gray-500 flex-shrink-0" />
        <span className="text-gray-700">{formatDateForDisplay(formData.date)}</span>
      </div>

      {/* Time and Duration */}
      <div className="flex items-center gap-2 text-sm">
        <Clock className="h-4 w-4 text-gray-500 flex-shrink-0" />
        <span className="text-gray-700">
          {formatTimeForDisplay(formData.time)} - {formatTimeForDisplay(endTime)}
          <span className="text-gray-400 ml-2">({formatDuration(formData.durationMinutes)})</span>
        </span>
      </div>
    </div>
  );
};

export default BookingSummary;
